import { t } from 'i18next'

const TRANSLATION_BASE_KEY = 'userArea.monitoringArea.tabHeaders'

export const TAB_LINK = Object.freeze({
  communications: 'communications',
  register: 'register',
  chat: 'chat',
  agenda: 'agenda',
  services: 'services',
  evolution: 'evolution',
  'declare-claim': 'declare-claim',
})

const TAB_TRANSLATION = Object.freeze({
  communications: `${TRANSLATION_BASE_KEY}.communications`,
  register: `${TRANSLATION_BASE_KEY}.register`,
  chat: `${TRANSLATION_BASE_KEY}.chat`,
  agenda: `${TRANSLATION_BASE_KEY}.agenda`,
  services: `${TRANSLATION_BASE_KEY}.services`,
  evolution: `${TRANSLATION_BASE_KEY}.evolution`,
  'declare-claim': `${TRANSLATION_BASE_KEY}.declare_claim`,
})

const declareClaimTab = () => ({
  title: t(TAB_TRANSLATION['declare-claim']).toUpperCase(),
  link: TAB_LINK['declare-claim'],
})

export const PreCSTabs = ({ isCoordinator } = {}) => [
  {
    title: t(TAB_TRANSLATION.communications).toUpperCase(),
    link: TAB_LINK.communications,
  },
  {
    title: t(TAB_TRANSLATION.register).toUpperCase(),
    link: TAB_LINK.register,
  },
  {
    title: t(TAB_TRANSLATION.evolution).toUpperCase(),
    link: TAB_LINK.evolution,
  },
  // ...(isCoordinator ? [declareClaimTab()] : []),
]

export const PostCsTabs = ({ isCoordinator } = {}) => [
  {
    title: t(TAB_TRANSLATION.chat).toUpperCase(),
    link: TAB_LINK.chat,
  },
  {
    title: t(TAB_TRANSLATION.agenda).toUpperCase(),
    link: TAB_LINK.agenda,
  },
  {
    title: t(TAB_TRANSLATION.services).toUpperCase(),
    link: TAB_LINK.services,
  },
  
  ...PreCSTabs({ isCoordinator }),
]
